module.exports = __webpack_public_path__ + "img/icon_expert.01b8a677.svg";